import { useState } from 'react';
import {
  Flex,
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  Button,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react';

import { getSession } from './App/auth';

export const Login = ({ setUser }) => {
  const [login, setLogin] = useState({});
  const [invalid, setInvalid] = useState(false);
  const handleFieldChange = ({ target: { name, value } }) =>
    setLogin({ ...login, [name]: value });
  const handleSubmit = () => {
    getSession(login).then(response => {
      if (typeof response.data.error === 'string') return setInvalid(true);
      setUser(response.data);
    });
  };

  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={useColorModeValue('gray.50', 'gray.800')}
    >
      <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
        <Stack align={'center'}>
          <Heading fontSize={'4xl'}>Sign in to your account</Heading>
        </Stack>
        <Box
          rounded={'lg'}
          bg={useColorModeValue('white', 'gray.700')}
          boxShadow={'lg'}
          p={8}
        >
          <Stack spacing={4}>
            <FormControl id="email" isInvalid={invalid}>
              <FormLabel>Email address</FormLabel>
              <Input name="email" type="email" onChange={handleFieldChange} />
              <FormErrorMessage>probably mistyped</FormErrorMessage>
            </FormControl>
            <FormControl id="password" isInvalid={invalid}>
              <FormLabel>Password</FormLabel>
              <Input
                name="password"
                type="password"
                onChange={handleFieldChange}
              />
              <FormErrorMessage>probably mistyped</FormErrorMessage>
            </FormControl>
            <Stack spacing={10}>
              <Button
                bg={useColorModeValue('blue.800', 'blue.300')}
                color={'white'}
                _hover={{
                  bg: useColorModeValue('blue.300', 'blue.800'),
                }}
                onClick={handleSubmit}
              >
                Sign in
              </Button>
            </Stack>
            <Box>
              In case of any login difficulties please contact{' '}
              <a href="mailto:info@canadamania.ru">info@canadamania.ru</a>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};
